import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
  Snackbar,
  Backdrop,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActionArea,
} from "@mui/material";

/* ===========================
   COMPONENTE STEP 0
=========================== */
const FlowEntryStep = ({
  onNext,                    // Avanza al siguiente paso (usuario normal)
  setUnidadesSeleccionadas,  // (Reservado para pasos posteriores)
  userRole,                  // Rol del usuario (ADMIN / USER)
  goGenerarUnidades,
  goGenerarSesiones,

}) => {
  const cardBaseSx = {
    width: "100%",
    height: "100%",
    maxWidth: 380,
    margin: "0 auto",
    borderRadius: "20px",
    overflow: "hidden",
    border: "1px solid #e0e0e0",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      borderColor: "#00C7DB",
      boxShadow: "0 8px 24px rgba(0, 199, 219, 0.25)",
      transform: "translateY(-4px)",
    },
    "&:hover .step0-card-header": {
      backgroundColor: "#00C7DB",
    },
    "&:hover .step0-card-desc": {
      color: "#00C7DB",
    },
  };

  const cardActionSx = {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  };

  const cardHeaderSx = {
    backgroundColor: "#9e9e9e",
    textAlign: "center",
    padding: "16px",
    transition: "background-color 0.3s ease",
    minHeight: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiCardHeader-content": {
      overflow: "hidden",
    },
    "& .MuiCardHeader-title": {
      color: "#ffffff",
      fontWeight: 500,
      letterSpacing: "0.3px",
      fontSize: "1.25rem",
      lineHeight: 1.2,
    },
  };

  const cardContentSx = {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    textAlign: "center",
    padding: { xs: "24px 12px", sm: "32px 16px" },
  };

  const cardImageSx = {
    width: { xs: 80, sm: 96 },
    height: { xs: 80, sm: 96 },
    objectFit: "contain",
    margin: "0 auto",
  };

  const cardDescriptionSx = {
    color: "#9e9e9e",
    lineHeight: 1.4,
    minHeight: "calc(1.4em * 3)",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
    overflow: "hidden",
    transition: "color 0.3s ease",
  };

  /* ===========================
     ESTADOS LOCALES
  =========================== */

  const [openSnackbar, setOpenSnackbar] = useState(false);
  // eslint-disable-next-line
  const [snackbarMsg, setSnackbarMsg] = useState("");
  // eslint-disable-next-line
  const [snackbarType, setSnackbarType] = useState("success");
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  /* ===========================
     HANDLERS DE NAVEGACIÓN
  =========================== */

  // Usuario normal → continuar flujo
  const handleContinuar = () => {
    onNext();
  };

  // Admin → ir al paso de generación de unidades
  const handleGenerarUnidades = () => {
    goGenerarUnidades();
  };

  // Admin → ir al paso de generación de sesiones
  const handleGenerarSesiones = () => {
    goGenerarSesiones();
  };

  /* ===========================
     RENDER
  =========================== */
  return (
    <>
      {/* ===========================
          VISTA ADMIN
      =========================== */}
      {(userRole === "ADMIN" || userRole === "DIRECTOR") ? (
        <Box
          sx={{
            width: "100%",
            padding: { xs: 2, sm: 3 },
            boxSizing: "border-box",
          }}
        >
          <Grid container spacing={3} justifyContent="center" alignItems="stretch">

            {/* CARD: GENERAR UNIDADES */}
            <Grid item xs={12} sm={6} md="auto" sx={{ display: "flex" }}>
              <Card sx={cardBaseSx}>
                <CardActionArea onClick={handleGenerarUnidades} sx={cardActionSx}>

                  <CardHeader
                    className="step0-card-header"
                    title="Generar Unidades"
                    sx={cardHeaderSx}
                  />

                  <CardContent sx={cardContentSx}>
                    <Box
                      component="img"
                      src="https://cdn-icons-png.flaticon.com/512/584/584796.png"
                      alt="Generar Unidades"
                      sx={cardImageSx}
                    />
                    <Typography variant="body2" className="step0-card-desc" sx={cardDescriptionSx}>
                      Crear y gestionar las unidades SAC.
                    </Typography>
                  </CardContent>

                </CardActionArea>
              </Card>
            </Grid>

            {/* CARD: GENERAR SESIONES */}
            {(userRole === "ADMIN" || userRole === "DIRECTOR") && (
              <Grid item xs={12} sm={6} md="auto" sx={{ display: "flex" }}>
                <Card sx={cardBaseSx}>
                  <CardActionArea onClick={handleGenerarSesiones} sx={cardActionSx}>

                    <CardHeader
                      className="step0-card-header"
                      title="Generar Sesiones"
                      sx={cardHeaderSx}
                    />

                    <CardContent sx={cardContentSx}>
                      <Box
                        component="img"
                        src="https://cdn-icons-png.flaticon.com/512/1828/1828817.png"
                        alt="Generar Sesiones"
                        sx={cardImageSx}
                      />
                      <Typography variant="body2" className="step0-card-desc" sx={cardDescriptionSx}>
                        Crear sesiones automáticas basadas en unidades SAC consolidadas.
                      </Typography>
                    </CardContent>

                  </CardActionArea>
                </Card>
              </Grid>
            )}

          </Grid>
        </Box>

      ) : (
        /* ===========================
            VISTA USUARIO NORMAL
        =========================== */
        <Box sx={{ marginTop: 3, textAlign: "center" }}>
          <Button variant="contained" onClick={handleContinuar}>
            Continuar
          </Button>
        </Box>
      )}

      {/* ===========================
          FEEDBACK (RESERVADO)
      =========================== */}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          severity={snackbarType}
          onClose={() => setOpenSnackbar(false)}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>

      <Backdrop open={loading} sx={{ color: "#fff", zIndex: 1300 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default FlowEntryStep;
